$(document).ready(function () {
    $('.see_more').on('click', function () {
        var self = $(this);
        self.parents('.change-height').find('.addHeight').animate({
            height: self.data('addheight'),
            overflow: 'visibile'
        }, 500, function () {
            self.css('display', 'none');
            self.parent().find('.see_less').css('display', 'inline');
            self.parents('.change-height').find('.addHeight').removeClass('shadow');
        });
    });

    $('.see_less').on('click', function () {
        var self = $(this);
        self.parents('.change-height').find('.addHeight').addClass('shadow');
        self.parents('.change-height').find('.addHeight').animate({
            height: self.data('seeheight'),
            overflow: 'hidden'
        }, 500, function () {
            self.css('display', 'none');
            self.parent().find('.see_more').css('display', 'inline');
        });
    });

});